import { IActivationComment } from "@/models";
import { ValidationObserver } from "vee-validate";
import { Vue, Component, Prop } from "vue-property-decorator";

@Component({
    name: "ActivationComments",
})
export default class ActivationComments extends Vue {
    @Prop({default: 0, type: Number, required: true})
    public activationId: number;

    @Prop({default: 0, type: Boolean, required: true})
    public canUserEdit: boolean;

    get comments(): IActivationComment[]{
        return this.$store.getters["app/activationComments"];
    }

    public message: string = "";

    async mounted(){
        await this.$store.dispatch("app/loadActivationComments", this.activationId);
    }

    async submit(): Promise<void> {
        try {
            await this.$store.dispatch(`app/addActivationComment`, {
                activationId: this.activationId,
                userId: this.$store.getters["account/user"].userId,
                message: this.message,
            })
            .then((response)=> {
                this.$emit("success", `The comment has been successfully added.`);
                this.message = "";
            })
            .catch((err) => {
                this.$emit("error", err);
            });
        }
        catch (error) {
            this.$emit("error", error);
        }
    }
}
